import React, { Component } from "react";

class SlideshowsModal extends Component {
  render() {
    const { onCancel, onAdd, onFileChange, value } = this.props;
    console.log(value);
    return (
      <div className="modal-body">
        <form onSubmit={(e) => e.preventDefault()}>
          <h3>Add Slideshow</h3>
          <div className="form-group browse-file">
            <label htmlFor="custom-file">
              Image:
              <span>(Recommend 2:1 e.g. 1200x600px)</span>
            </label>
            {value && <label>{value.name || "undefined file"}</label>}
            <label className="custom-file">
              <input
                type="file"
                id="file2"
                className="custom-file-input"
                onChange={(e) => onFileChange(e.target.files[0])}
              />
              <span className="custom-file-control" />
            </label>
          </div>
          <div className="modal-botton">
            <button
              className="btn button gray-btn"
              type="cancel"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className="btn button green-btn"
              type="submit"
              onClick={onAdd}
            >
              Add Slideshow
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default SlideshowsModal;



// WEBPACK FOOTER //
// ./src/views/slideshow/SlideshowsModal.js